import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle, RotateCcw } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = params.get("booking_id");

  return (
    <section className="max-w-xl mx-auto px-5 sm:px-8 py-28">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="rounded-sm bg-navy-light border border-gold/20 p-10 text-center" data-testid="payment-cancel">
        <XCircle className="h-16 w-16 text-slate-400 mx-auto mb-5" />
        <h1 className="font-heading text-3xl font-bold text-white">Payment cancelled</h1>
        <p className="text-slate-300 mt-3">No charge was made. Your booking request {bookingId ? "is saved" : ""} — you can try again or pay the driver on arrival.</p>
        <div className="mt-8 flex flex-wrap gap-4 justify-center">
          <button onClick={() => navigate("/book")} className="inline-flex items-center gap-2 rounded-full bg-gold px-8 py-3.5 font-semibold text-navy transition-transform duration-200 hover:-translate-y-0.5 hover:bg-gold-light" data-testid="cancel-retry-btn">
            <RotateCcw className="h-4 w-4" /> Try again
          </button>
          <Link to="/" className="inline-flex items-center rounded-full border border-gold/40 px-8 py-3.5 font-semibold text-white hover:border-gold hover:text-gold transition-colors duration-200">Home</Link>
        </div>
      </motion.div>
    </section>
  );
}
